/**
 * @flow
 */

import {
    Map
} from 'immutable';
import {
    pick
} from 'lodash';
import { format, addDays } from 'date-fns';

import {
    saveState,
    loadState
} from '../lib/sessionStorage';

const STATE_KEY = 'masterAppointments';
const dateFmt = 'yyyy-MM-dd';

const cachedState = loadState(STATE_KEY) || {
    fromDate: format(new Date(), dateFmt),
    toDate: format(addDays(new Date(), 7), dateFmt),
    master: null,
};

const initialState = new Map(cachedState);

export default (state: Object = initialState, action: Object) => {
    switch (action.type) {
        case 'MASTER_APPOINTMENTS.SET_DATE':
            {
                Object.assign(cachedState, pick(action, ['fromDate', 'toDate']));
                saveState(STATE_KEY, cachedState);
                return state
                    .set('fromDate', action.fromDate)
                    .set('toDate', action.toDate);
            }
        case 'MASTER_APPOINTMENTS.SET_MASTER':
            {
                Object.assign(cachedState, pick(action, ['master']));
                saveState(STATE_KEY, cachedState);
                return state.set('master', action.master);
            }
        default:
            {
                return state;
            }
    }
};
